import axios from "axios";
import { authService } from "services/auth/auth_service";

const BASE_API_URL = process.env.REACT_APP_URL_API ?? '';
const API_URL = BASE_API_URL + '/manage/permissions';

export const getPermissionsList= async (
    filters: any
): Promise<any> => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.get(`${API_URL}`, {
    params: filters || {},
    headers: {
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};

export const getPermission = async (uuid: string): Promise<any>  => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.get(`${API_URL}/${uuid}`, {
    headers: {
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};


export const getModulesList= async (
  filters: any
): Promise<any> => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.get(`${API_URL}/modules`, {
    params: filters || {},
    headers: {
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};



export const createPermission = async (data: any)  => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.post(`${API_URL}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${eseiafToken}`,
      }
    }
  );

  return response.data;
};


export const updatePermission = async (uuid: string, data: any) => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.put(`${API_URL}/${uuid}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${eseiafToken}`,
      }
    }
  );

  return response.data;
};

export const deletePermission = async (uuid: string) => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.delete(`${API_URL}/${uuid}`, {
    headers: {
      Authorization: `Bearer ${eseiafToken}`,
    },
  });

  return response.data;
};


export const changePermissionStatus = async (uuid: string, isActive = false) => {
  const eseiafToken = authService.getTokenAPIInterna();

  const response = await axios.put(
    `${API_URL}/${uuid}/change-status`,
    { is_active: isActive },
    {
      headers: {
        Authorization: `Bearer ${eseiafToken}`,
      },
    }
  );

  return response.data;
};
